const FIELD_ERROR_MESSAGE = {
  commonField: {
    required: "Field is required",
    invalid: ""
  },
  pincode: {
    required: "Pin code is required",
    invalid: "Please enter a valid pin code"
  },
  pan: {
    required: "Pan number is required",
    invalid: "Please enter a valid PAN/TAN number"
  },
  name: {
    required: "Owner's name is required",
    invalid: "Please enter a valid name"
  },
  mobile: {
    required: "Mobile number is required",
    invalid: "Please enter a valid mobile number"
  },
  contactNumber: {
    required: "Contact number is required"
  },
  mobileSendQuotes: {
    required: "Number is required",
    invalid: "Please enter a valid number"
  },
  mmv: {
    required: "Make & model is required",
    invalid: ""
  },
  ncb: {
    required: "Please select one of the options",
    invalid: ""
  },
  pped: {
    required: "Policy expiry date is required",
    invalid: ""
  },
  cng: {
    required: "Please select one of the options",
    invalid: "External CNG kit value is invalid",
    value: "External CNG kit value is required"
  },
  commercial: {
    required: "Please select one of the options",
    invalid: ""
  },
  regdYear: {
    required: "Registration year is required",
    invalid: ""
  },
  regdMonth: {
    required: "Registration months is required",
    invalid: ""
  },
  claimedPolicy: {
    required: "Please select one of the options",
    invalid: ""
  },
  fuelType: {
    required: "Fuel type is required",
    invalid: ""
  },
  variant: {
    required: "Variant is required",
    invalid: ""
  },
  tpPped: {
    required: "Third Party expiry date is required",
    invalid: ""
  },
  odPped: {
    required: "Own Damage expiry date is required",
    invalid: ""
  },
  engine: {
    required: "Engine number is required",
    invalid: "Please enter a valid engine number"
  },
  chassis: {
    required: "Chassis number is required",
    invalid: "Please enter a valid chassis number"
  },
  email: {
    required: "Email is required",
    invalid: "Please enter a valid email address"
  },
  emailSendQuotes: {
    required: "Email is required",
    invalid: "Please enter a valid Email ID"
  },
  otp: {
    required: "Otp is required",
    invalid: "Please enter a valid otp"
  },
  gst: {
    required: "GST number is required",
    invalid: "Please enter a valid GST number."
  },
  carNumber: {
    required: "Car number is required",
    invalid: "Please enter a valid car number"
  },
  bikeNumber: {
    required: "Bike number is required",
    invalid: "Please enter a valid bike number"
  },
  address: {
    required: "Address is required",
    invalid: ""
  },
  city: {
    required: "City is required",
    invalid: ""
  },
  expiryMonth: {
    required: "Expiry month is required",
    invalid: ""
  },
  policyStartDate: {
    required: "New policy start date is required",
    invalid: ""
  },
  policyStatus: {
    required: "Current policy status is required",
    invalid: ""
  },
  mmvBike: {
    required: "Brand & model is required",
    invalid: ""
  },
  previousInsurer: {
    required: "Previous insurer is required"
  },
  policyDate: {
    required: "Policy date is required"
  },
  nominee: {
    invalid: "Nominee age should be above or equal to 18"
  },
  flatDetails: {
    required: "Flat details is required",
    invalid: ""
  },
  landmark: {
    required: "Landmark is required"
  },
  purchaseDate: {
    required: "Car delivery date is required"
  }
};

export default FIELD_ERROR_MESSAGE;
